module.exports = __webpack_public_path__ + "img/hands.3ac2279d.png";